import React, { FC } from 'react';
import { createPortal } from 'react-dom';

interface iAlert {
  title: string;
  subtitle: string | React.ReactNode;
  onClose: () => void;
  actions?: { label: string; onClick?: () => void }[];
}
const Alert: FC<iAlert> = ({ title, subtitle, onClose, actions }) => {
  const wrapper = document.querySelector('#portal');

  if (!wrapper) return null;
  return createPortal(
    <div className='alert-wrapper'>
      <div className='alert-content'>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <div className='actions'>
          {!actions && <button onClick={onClose}>Close</button>}
          {actions?.map((action) => (
            <button
              onClick={() => {
                action?.onClick?.();
                onClose();
              }}
              key={action.label}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>,
    wrapper,
  );
};

export default Alert;
